class BESSAppProjectEditorSavedEvent extends BESSAppEvent {

    static name = "BESSAppProjectEditorSavedEvent";

    constructor(results=null) {
        super(BESSAppProjectEditorSavedEvent.name);
        if(results !== null) {
            this.profilers = _.map(results.profilers, (x) => new BESSAppProjectEditorSavedEvent_ProfilerData(x));
        } else {
            this.profilers = [];
        }
    }
}

class BESSAppProjectEditorSavedEvent_ProfilerData {

    constructor(data) {
        this.editorId = data['editor_id'];
        this.view = data['view'];
        this.data = data['data'];
    }
}